module.exports = __webpack_public_path__ + "img/julian-brenman.269e9ae9.jpg";